import { render, staticRenderFns } from "./ResellerCreate.vue?vue&type=template&id=5eb7be87"
import script from "./ResellerCreate.vue?vue&type=script&lang=js"
export * from "./ResellerCreate.vue?vue&type=script&lang=js"
import style0 from "./ResellerCreate.vue?vue&type=style&index=0&id=5eb7be87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports